import React, { useEffect, useState } from 'react';
import InquiryLabelsListing from './InquiryLabelsListing';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { setPage, setRowsPerPage, setSearchValue, setItems, setTotalItems , setIsTableLoading } from 'src/redux/slices/InquiryLabelsSlice';
import AddInquiryLabelsFormWrapper from '../Add/AddInquiryLabelsFormWrapper';
import ATMMenu from 'src/components/UI/atoms/ATMMenu/ATMMenu';
import { showConfirmationDialog } from 'src/utils/showConfirmationDialog';
import { showToast } from 'src/utils/showToaster';
import EditInquiryLabelsFormWrapper from '../Edit/EditInquiryLabelsFormWrapper';
import { RxPencil1 } from "react-icons/rx";
import { MdDeleteOutline } from "react-icons/md";
import { useDeleteInquiryLabelMutation, useGetInquiryLabelPaginationQuery } from 'src/services/InquiryLabelServices';

type Props = {};

const InquiryLabelsListingWrapper = (props: Props) => {
    const [inquiryLabelId, setInquiryLabelId] = useState()

    const dispatch = useDispatch();
    const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
        useSelector((state: RootState) => state.inquryLabel);

    const [deleteInquiryLabel] = useDeleteInquiryLabelMutation()

    const { data, isLoading, isFetching } = useGetInquiryLabelPaginationQuery({
        searchValue: searchValue,
        page: page,
        dateFilter: {},
        orderBy: "createdAt",
        orderByValue: -1,
        isPaginationRequired: true,
    })

    useEffect(() => {
        if (isLoading || isFetching) {
            dispatch(setIsTableLoading(true));
        } else {
            dispatch(setItems(data?.data || []));
            dispatch(setTotalItems(data.setTotalItems || 0));
            dispatch(setIsTableLoading(false))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    const [isOpenAddDailog, setIsOpenAddDailog] = useState(false)
    const [isOpenEditDialog, setIsOpenEditDialog] = useState(false)

    const getActionOptions = (row: any) => {
        return [
            {
                label: (
                    <div className="flex items-center gap-2 text-secondary-main">
                        <RxPencil1 className="text-lg" /> Edit
                    </div>
                ),
                onClick: () => {
                    setIsOpenEditDialog(true);
                    setInquiryLabelId(row._id)
                },
            },
            {
                label: (
                    <div className="flex items-center gap-2 font-semibold text-red-600">
                        <MdDeleteOutline className="text-lg" /> Delete
                    </div>
                ),
                onClick: () => {
                    showConfirmationDialog({
                        title: "Heads Up",
                        text: "Are you sure want to Delete this Mode ?",
                        icon: "question",
                        showCancelButton: true,
                        next: () => {
                            deleteInquiryLabel(row?._id).then((res: any) => {
                                if (res?.error) {
                                    showToast("error", res?.error?.data?.message);
                                } else {
                                    if (res?.data?.status) {
                                        showToast("success", res?.data?.message);
                                    } else {
                                        showToast("error", res?.data?.message);
                                    }
                                }
                            });

                        },
                    });
                },
            },
        ];
    };

    const columns: columnTypes[] = [
        {
            field: 'inquiryLabel', headerName: 'Name', flex: 'flex-[1_1_0%]',
        }, {
            noAuthRequired: true,
            field: "action",
            headerName: "Action",
            flex: "flex-[1_1_0%]",
            renderCell: (row: any) => {
                const options = getActionOptions(row);
                return <ATMMenu options={options} orientation="vertical" />;
            },
        },

    ];

    return (
        <div>
            <InquiryLabelsListing
                onAddNew={() => setIsOpenAddDailog(true)}
                columns={columns}
                rows={items}
                paginationProps={{
                    isTableLoading,
                    totalItems,
                    page,
                    rowsPerPage,
                    searchValue,
                    setPage: (newPage) => dispatch(setPage(newPage)),
                    setRowsPerPage: (newRowsPerPage) => dispatch(setRowsPerPage(newRowsPerPage)),
                    setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
                }}
            />
            {isOpenAddDailog ? (
                <AddInquiryLabelsFormWrapper onClose={() => setIsOpenAddDailog(false)} />
            ) : null}
            {isOpenEditDialog ? (
                <EditInquiryLabelsFormWrapper
                    id={inquiryLabelId}
                    onClose={() => setIsOpenEditDialog(false)} />
            ) : null}
        </div>
    );
};

export default InquiryLabelsListingWrapper;